import { render, staticRenderFns } from "./default-homepage-reviews.vue?vue&type=template&id=1a24994e&scoped=true&"
import script from "./default-homepage-reviews.vue?vue&type=script&lang=js&"
export * from "./default-homepage-reviews.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=1a24994e&scoped=true&lang=css&"
import style1 from "./default-homepage-reviews.vue?vue&type=style&index=1&id=1a24994e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24994e",
  null
  
)

export default component.exports